const roleMap = {
  bhp: 'Behavioral Health Professional',
  pm: 'Program Manager',
  pc: 'Program Coordinator',
  admin: 'Administrator',
  auditor: 'Auditor',
};

export const authorization = {
  getUser: async (uid, firestore) => {
    const user = await firestore.collection('users').doc(uid).get();
    return user;
  },
  getFollowing: async (uid, firestore) => {
    const following = await firestore
      .collection('users')
      .doc(uid)
      .collection('following')
      .get();
    return following;
  },
  getFollowingClient: async (uid, firestore) => {
    const followingClient = await firestore
      .collection('users')
      .doc(uid)
      .collection('followingClient')
      .get();
    return followingClient;
  },
  getFollowers: async (uid, firestore) => {
    const following = await firestore
      .collection('users')
      .doc(uid)
      .collection('followers')
      .get();
    return following;
  },
  getFollowersClient: async (uid, firestore) => {
    const followingClient = await firestore
      .collection('users')
      .doc(uid)
      .collection('followersClient')
      .get();
    return followingClient;
  },
  getUserData: (user) => {
    const userData = user && user.exists && user.data();
    return userData;
  },
  hasRole: (role, userData) => {
    if (!userData) return false;

    if (typeof userData === 'string') {
      userData = userData.toLowerCase();
      if (userData === role.toLowerCase()) return true;
      if (userData === roleMap[role].toLowerCase()) return true;
      return false;
    }

    if (Array.isArray(role))
      return role.some((r) => authorization.hasRole(r, userData));

    role = role.toLowerCase();

    const hasInRoleArray =
      userData &&
      userData.roles &&
      userData.roles.some((r) => r.toLowerCase() === role);
    if (hasInRoleArray === true) return true;

    const hasRoleDirectly =
      userData && userData.role && userData.role.toLowerCase() === role;
    if (hasRoleDirectly) return true;

    const roleLongName = roleMap[role];
    if (!roleLongName) return false;

    const hasRoleLongNameDirectly =
      userData &&
      userData.role &&
      userData.role.toLowerCase() === roleLongName.toLowerCase();
    return hasRoleLongNameDirectly;
  },
};
